import { AppDispatch, RootState } from "../../store";
import {  startLoginUserAdmin } from "../../store/auth";

import { useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Link as RouterLink, useNavigate } from "react-router-dom";

import {
  Grid,
  TextField,
  Button,
  Link,
  InputAdornment,
  IconButton,
  CircularProgress,
  Alert,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";


import { regularExps } from "../../helpers/validators";
import { LoginAdminLayout } from "../../layouts/LoginAdminLayout";

type Inputs = {
  email: string;
  password: string;
};

export const LoginAdminPage = () => {
  // Usa useSelector para acceder al estado 'status' de tu slice de autenticación
  const { status, errorMessage } = useSelector(
    (state: RootState) => state.auth
  );

  const isChecking = status === "checking";

  /* PARA HACER EL LOGIN */
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<Inputs>({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const onSubmit = async (data: Inputs) => {
    const result = await dispatch(startLoginUserAdmin(data.email, data.password));

    if (result.success) {
      navigate("/admin");
    }
  };

  // Estado para controlar si la contraseña se muestra o no
  const [showPassword, setShowPassword] = useState(false);

  // Función para cambiar el estado de showPassword
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  // Función para manejar el mousedown en el IconButton, (que se ponga manita al pasar por el ojo)
  const handleMouseDownPassword = (event: any) => {
    event.preventDefault();
  };

  return (
    <LoginAdminLayout title="Administrativo" linkTo="register">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container alignItems="center" justifyContent="center">
          <Grid item xs={12} mb={3}>
            <TextField
              variant="standard"
              label="Correo"
              type="email"
              placeholder="ejemplo@correo.com"
              fullWidth
              color="secondary"
              {...register("email", {
                required: "Este campo es requerido",
                pattern: {
                  value: regularExps.email,
                  message: "Este campo debe ser un correo electrónico válido",
                },
              })}
              error={!!errors.email}
              helperText={errors.email?.message}
              InputLabelProps={{
                shrink: true, // Esto mantiene el label reducido y arriba
                style: {
                  fontSize: "1.4rem", // Aumenta el tamaño de la fuente del label
                  //transform: 'translate(14px, -6px) scale(1)', // Ajusta la posición del label
                },
              }}
              InputProps={{
                style: {
                  paddingTop: "8px", // Aumenta el padding superior del input para separarlo del label
                },
              }}
            />
          </Grid>

          <Grid item xs={12} mb={2}>
            <TextField
              variant="standard"
              label="Contraseña"
              type={showPassword ? "text" : "password"}
              placeholder="Tu contraseña"
              fullWidth
              {...register("password", {
                required: "Este campo es requerido",
              })}
              error={!!errors.password}
              helperText={errors.password?.message}
              color="secondary"
              InputLabelProps={{
                shrink: true, // Esto mantiene el label reducido y arriba
                style: {
                  fontSize: "1.4rem", // Aumenta el tamaño de la fuente del label
                  //transform: 'translate(14px, -6px) scale(1)', // Ajusta la posición del label
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
                style: {
                  paddingTop: "8px", // Aumenta el padding superior del input para separarlo del label
                },
              }}
            />
          </Grid>



          <Grid item xs={12}>
            <Grid item mb={2} display={errorMessage ? "" : "none"}>
              <Alert severity="error">{errorMessage}</Alert>
            </Grid>

            <Button
              disabled={isChecking}
              variant="contained"
              type="submit"
              color="primary"
              fullWidth

              sx={{ borderRadius: 2, padding: 1.5, fontSize: "1.1rem", my: 2 }}
            >
              {isChecking ? (
                <CircularProgress style={{ color: "#CE3197", padding: 10 }} />
              ) : (
                "Iniciar sesión"
              )}
            </Button>
          </Grid>

          
        </Grid>
      </form>
    </LoginAdminLayout>
  );
};
